import { action } from 'satcheljs/lib/legacy';
export default action('removeMentionTuple')(function removeMentionTuple(viewState, nodeId) {
    delete viewState.atMentionTuples[nodeId];
});
//# sourceMappingURL=removeMentionTuple.js.map